module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v2.9.1-142.vue");


//////////////////
// WEBPACK FOOTER
// ./en/changelog/v2.9.1.md
// module id = 559
// module chunks = 227